import APICaller from '@/shared/mixins/APICaller';

export function createLegacyThemeRepository(api = APICaller.methods) {
  let pending;
  const get = url => new Promise((resolve, reject) => api._getAPICall(url,
    new APICaller.SuccessHandler(response => resolve(response.data)),
    new APICaller.FailureHandler('002', 'Error cambiando el tema de color.', reject),
    { loadingOverlay: false, displayErrors: false }));

  return {
    toggle() {
      if (!pending) pending = get('/usuarios/change-gd-interface-color')
        // The legacy mutation returns no colour: read the authoritative preference.
        .then(() => get('/usuarios/gd-interface-color'))
        .then(color => {
          if (color !== 'white' && color !== 'black') throw new Error('Invalid theme');
          return color === 'black';
        })
        .finally(() => { pending = null; });
      return pending;
    }
  };
}

export default createLegacyThemeRepository();
